<template>
  <div
    v-if="isVisible"
    class="mb-25"
    :class="{
      marginClasses,
      globalClasses,
      container: !parentType,
    }"
  >
    <div
      class="paragraph-two-columns grid gap-30 lg:grid-cols-12"
      :class="{
        'items-start': options.alignment === 'top',
        'items-center': options.alignment === 'center',
        'items-end': options.alignment === 'bottom',
      }"
    >
      <BlokkliField
        :list="paragraphs"
        name="field_paragraphs"
        :class="{
          'lg:col-span-6': options.columns === 'equal',
          'lg:col-span-8': options.columns === 'wideLeft',
          'lg:col-span-4': options.columns === 'wideRight',
        }"
      />
      <BlokkliField
        name="field_paragraphs_aside"
        :list="paragraphsAside"
        class="gap-30 paragraph-two-columns-aside"
        :class="{
          'order-first': options.reverse,
          'items-start': options.alignment === 'top',
          'items-center': options.alignment === 'center',
          'items-end': options.alignment === 'bottom',
          'lg:col-span-6': options.columns === 'equal',
          'lg:col-span-4': options.columns === 'wideLeft',
          'lg:col-span-8': options.columns === 'wideRight',
        }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphTwoColumnsFragment } from '#graphql-operations'

defineOptions({
  name: 'ParagrapTwoColumns',
})

const { options, parentType } = defineBlokkli({
  bundle: 'two_columns',
  globalOptions: ['marginTop', 'region'],
  options: {
    columns: {
      type: 'radios',
      label: 'Columns',
      displayAs: 'grid',
      options: {
        equal: { label: 'Equal', columns: [1, 1] },
        wideLeft: { label: 'Wide left', columns: [8, 3] },
        wideRight: { label: 'Wide right', columns: [3, 8] },
      },
      default: 'equal',
    },
    reverse: {
      type: 'checkbox',
      label: 'Reverse',
      default: false,
    },
    alignment: {
      type: 'radios',
      label: 'Alignment',
      options: {
        top: 'Top',
        center: 'Center',
        bottom: 'Bottom',
      },
      default: 'top',
    },
  },

  editor: {
    disableEdit: true,
  },
  propsFieldMapping: {
    paragraphs: { type: 'field', name: 'field_paragraphs' },
    paragraphsAside: { type: 'field', name: 'field_paragraphs_aside' },
  },
})

const { isVisible, marginClasses, globalClasses } =
  useMappedParagraphOptions(options)

defineProps<{
  paragraphs?: ParagraphTwoColumnsFragment['paragraphs']
  paragraphsAside?: ParagraphTwoColumnsFragment['paragraphsAside']
}>()

const imageStyle = computed(() => {
  switch (options.value.columns) {
    case 'equal':
    case 'wideLeft':
      return 'teaser_half'
  }

  return 'teaser_half'
})

provide('imageStyle', imageStyle)
</script>

<style lang="postcss">
.paragraph-two-columns-aside {
  > * {
    flex: 1;
  }
}
</style>
